import React, { useState, useContext } from 'react'
import { createPortal } from 'react-dom'
import { CSSTransition } from 'react-transition-group'
import { GlobalContext } from '../../context/GlobalState'
import Loading from '../Loading'
import styles from './Modal.module.css'

const AddItemModal = ({ showModal, setShowModal, listID }) => {
  const context = useContext(GlobalContext)
  const [ item, setItem ] = useState({
    itemText: '',
    note: '',
    qty: 1,
    cost: 0,
    listID: listID
  })

  /* update local state */
  const onChange = e => {
    setItem({...item, [e.target.name]: e.target.value })
  }

  /* POST new item to server, close modal if successful else error */
  const onSubmit = async e => {
    e.preventDefault()
    context.addItem(item)
    setShowModal(false)
    setItem({itemText: '', note: '', cost: 0, qty: 1, listID: listID })
  }

  /* Cancel and close modal */
  const cancel = () => {
    setItem({itemText: '', note: '', qty: 1, cost: 0, listID: listID })
    setShowModal(false)
  }

  return showModal ? createPortal
  (
    <CSSTransition
      in={showModal}
      timeout={{ enter: 0, exit: 300 }}
      unmountOnExit
    >
      <div className="modal">
        {context.status === 'pending' ? 
            <Loading /> : (
        <div className="modal-content">
          <div className="modal-header">
            <h4>Add Item</h4>
          </div>
          <form onSubmit={onSubmit}>
            <input
              type="text"
              placeholder="Item Name..."
              name="itemText" 
              value={item.itemText}
              onChange={onChange}>
            </input>
            <input 
              type="text" 
              placeholder="Quantity..."
              name="qty" 
              value={item.qty}
              onChange={onChange}>
            </input>
            <input 
              type="text" 
              placeholder="Note..."
              name="note" 
              value={item.note}
              onChange={onChange}>
            </input>
            { context.lists.filter(list => list.listID === listID)[0].hasBudget === 'Y' &&
              <input 
                type="text" 
                placeholder="Cost..."
                name="cost" 
                value={item.cost}
                onChange={onChange}>
              </input>
            }
            <div className={styles.modal_bttn_container}>
              <input type="submit" className={styles.save_bttn} value="Save"></input>
              <input type="button" className={styles.cancel_bttn} value="Cancel" onClick={cancel}></input>
            </div>
          </form>
        </div>
        )}
      </div>
    </CSSTransition>,
    document.body
  )
  : null
}

export default AddItemModal